module.exports = __webpack_public_path__ + "ec4c9962ba54eb91787aa93d361c10a8.ttf";